'use strict';

var svaneTvis = svaneTvis || {};

svaneTvis.video = svaneTvis.video || new function () {

    this.init = function () {
        const videos = document.querySelectorAll('.js-video');
        const playVideo = function () {
            for (let i = 0; i < videos.length; i++) {
                const video = videos[i];
                const iframe = video.querySelector('iframe');
                const src = iframe.getAttribute('data-src');
                const trigger = video.querySelector('.js-video-trigger');

                if (window.innerWidth > 767) {
                    if (isInViewport(video)) {
                        if (iframe.dataset.playing != '1') {
                            iframe.setAttribute('src', src);
                            iframe.setAttribute('data-playing', '1');
                        }
                    }
                } else {
                    trigger.addEventListener('click', function () {
                        iframe.setAttribute('src', src);
                        trigger.style.display = 'none';
                    });
                }
            }
        };
        window.addEventListener('load', function (event) {
            if (videos) {
                playVideo();
            }
        });

        window.addEventListener('scroll', function (event) {
            if (videos) {
                playVideo();
            }
        }, false);

        // Is in viewport helper
        const isInViewport = function (elem) {
            const bounding = elem.getBoundingClientRect();
            return (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        };
    };
}();
